import React, { useState } from 'react';
import './index.scss';

function LandingPage() {
    const destination = 'https://koreanmate.onelink.me/Tkco/y94asact';
    const heroImages = ['/img/hero1.jpg', '/img/hero2.jpg', '/img/hero3.jpg', '/img/hero4.jpg', '/img/hero5.jpg'];
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const handlePrevImage = () => {
        setCurrentImageIndex((prev) => (prev === 0 ? heroImages.length - 1 : prev - 1));
    };

    const handleNextImage = () => {
        setCurrentImageIndex((prev) => (prev === heroImages.length - 1 ? 0 : prev + 1));
    };

    return (
        <div className="LandingPage">
            <div className="LandingContainer">
                {/* Top Background Wrapper */}
                <div className="TopBackgroundWrapper">
                    {/* Hero Wrapper */}
                    <div className="HeroWrapper" style={{
                        backgroundImage: 'url(/img/herobg.png)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}>
                    {/* Top Section */}
                    <section className="TopSection">
                    <div className="TopInner">
                        {/* Header */}
                        <div className="HeaderRow">
                            <div className="HeaderLeft">
                                <div className="LogoWrapper">
                                    <img src="/svg/landinglogo.png" alt="MATE Logo" />
                                </div>
                                <div className="HeaderTextWrapper">
                                    <p>Talk and Korean Learn</p>
                                </div>
                            </div>
                            <div className="HeaderRight">
                                <div className="TitleWrapper">
                                    <p>MATE</p>
                                </div>
                            </div>
                        </div>

                        {/* Hero Image */}
                        <div className="HeroImageSection">
                            <div className="HeroImageBox">
                                <img src={heroImages[currentImageIndex]} alt="Hero" />
                            </div>
                        </div>
                    </div>

                    {/* Controls */}
                    <div className="ControlsRow">
                        <div className="ControlButton" onClick={handlePrevImage} style={{ cursor: 'pointer' }}>
                            <div className="ControlCircle">
                                <img src="/img/arrowleft.svg" alt="Previous" />
                            </div>
                        </div>
                        <div className="ControlButton" onClick={handleNextImage} style={{ cursor: 'pointer' }}>
                            <div className="ControlCircle">
                                <img src="/img/arrowright.svg" alt="Next" />
                            </div>
                        </div>
                    </div>

                    {/* CTA Button */}
                    <button className="CTAButton" onClick={() => window.open(destination, "_blank")}>
                        <p>Mulai Langsung</p>
                        <div className="CTAIcon">
                            <img src="/svg/icon_arrow.svg" alt="Arrow" />
                        </div>
                    </button>
                    </section>

                    {/* Features Section */}
                    <section className="FeaturesSection">
                    <div className="FeaturesSectionInner">
                        <div className="FeaturesTitle">
                            <p>Weekend atau weekday,</p>
                            <p>belajar Bahasa Korea langsung dari ujung jari.</p>
                        </div>
                        <div className="FeaturesGrid">
                            {/* Card 1 */}
                            <div className="FeatureCard">
                                <div className="CardTop">
                                    <div className="CardIcon">
                                        <img src="/svg/Sparkels.svg" alt="Icon" />
                                    </div>
                                    <div className="CardTitle">
                                        <p>24 Jam</p>
                                        <p>Kapan Saja</p>
                                    </div>
                                </div>
                                <div className="CardBottom">
                                    <p className="CardBold">Belajar dengan 20+ AI Mate</p>
                                    <p className="CardLight">AI Mate selalu siap bantu kamu dengan penjelasan yang ramah.</p>
                                </div>
                            </div>

                            {/* Card 2 */}
                            <div className="FeatureCard">
                                <div className="CardTop">
                                    <div className="CardIcon">
                                        <img src="/svg/heart-rate.svg" alt="Icon" />
                                    </div>
                                    <div className="CardTitle">
                                        <p>Benahi pelafalanmu</p>
                                    </div>
                                </div>
                                <div className="CardBottom">
                                    <p className="CardBold">Latihan pengucapan jadi mudah lewat voice chat</p>
                                    <p className="CardLight">Nggak perlu khawatir soal pelafalan sulit—dengar contoh dari penutur asli kapan saja.</p>
                                </div>
                            </div>

                            {/* Card 3 */}
                            <div className="FeatureCard">
                                <div className="CardTop">
                                    <div className="CardIcon">
                                        <img src="/svg/Users_3.svg" alt="Icon" />
                                    </div>
                                    <div className="CardTitle">
                                        <p>Teman Belajar</p>
                                    </div>
                                </div>
                                <div className="CardBottom">
                                    <p className="CardBold">Bergabung dengan 30.000+ pelajar lainnya</p>
                                    <p className="CardLight">Bagikan info soal belajar bahasa Korea bersama teman komunitasmu</p>
                                </div>
                            </div>

                            {/* Card 4 */}
                            <div className="FeatureCard">
                                <div className="CardTop">
                                    <div className="CardIcon">
                                        <img src="/svg/list_check.svg" alt="Icon" />
                                    </div>
                                    <div className="CardTitle">
                                        <p>Guru Bahasa Korea yang Tepat Untukmu</p>
                                    </div>
                                </div>
                                <div className="CardBottom">
                                    <p className="CardBold">Mulai belajar tanpa bingung</p>
                                    <p className="CardLight">Kurikulum kami bantu kamu tahu harus mulai dari mana dan belajar apa dulu.</p>
                                </div>
                            </div>

                            {/* Card 5 */}
                            <div className="FeatureCard">
                                <div className="CardTop">
                                    <div className="CardIcon">
                                        <img src="/svg/Notes-lines-alt.svg" alt="Icon" />
                                    </div>
                                    <div className="CardTitle">
                                        <p>Berita Korea Terkini</p>
                                    </div>
                                </div>
                                <div className="CardBottom">
                                    <p className="CardBold">Belajar bahasa Korea sambil membaca berita terbaru dari Korea</p>
                                    <p className="CardLight">Hiburan, olahraga, kesehatan, dan banyak lagi. Satu tempat untuk belajar sekaligus update berita Korea.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* CTA Button */}
                    <button className="CTAButton" onClick={() => window.open(destination, "_blank")}>
                        <p>Mulai Langsung</p>
                        <div className="CTAIcon">
                            <img src="/svg/icon_arrow.svg" alt="Arrow" />
                        </div>
                    </button>
                    </section>
                    </div>

                </div>

                {/* AI Mate Section */}
                <section className="AIMateSection">
                    {/* Wave Divider */}
                    <section className="WaveDivider">
                        <div className="WaveWrapper">
                            <img src="/svg/wave.svg" alt="Wave" className="WaveSVG" />
                        </div>
                    </section>

                    <div className="AIMateInner">
                        <div className="AIMateHeader">
                            <div className="AIMateBadge">
                                <p>AI Mate</p>
                            </div>
                            <div className="AIMateTitle">
                                <p>Dari obrolan sehari-hari hingga percakapan romantis,</p>
                                <p>Mate bisa menjadi teman Koreamu!</p>
                            </div>
                        </div>
                        
                        <div className="AIMateCardsWrapper">
                            <div className="AIMateCards">
                                {/* Card 1 */}
                                <div className="AIMateCard">
                                    <div className="AIMateCardImage">
                                        <img src="/img/aichatimg1.png" alt="Voice Chat" />
                                    </div>
                                    <div className="AIMateCardOverlay">
                                        <p className="AIMateCardTitle">Voice Chat</p>
                                        <p className="AIMateCardDescription">Bisa berbicara secara real-time dengan menggunakan metode push-to-talk.</p>
                                    </div>
                                </div>

                                {/* Card 2 */}
                                <div className="AIMateCard">
                                    <div className="AIMateCardImage">
                                        <img src="/img/aichatimg2.png" alt="Chat Mode" />
                                    </div>
                                    <div className="AIMateCardOverlay">
                                        <p className="AIMateCardTitle">Mode Chat Lebih Canggih</p>
                                        <p className="AIMateCardDescription">Experience enhanced performance and smarter conversations in an upgraded chat mode.</p>
                                    </div>
                                </div>

                                {/* Card 3 */}
                                <div className="AIMateCard">
                                    <div className="AIMateCardImage">
                                        <img src="/img/aichatimg3.png" alt="Chat Mode" />
                                    </div>
                                    <div className="AIMateCardOverlay">
                                        <p className="AIMateCardTitle">20 + AI Mate</p>
                                
                                        <p className="AIMateCardDescription">Temui berbagai karakter AI unik yang terus bertambah setiap waktu.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* CTA Button */}
                    <div className="AIMateCTA">
                        <button className="CTAButton CTAPurple" onClick={() => window.open(destination, "_blank")}>
                            <p>Mulai Langsung</p>
                            <div className="CTAIcon">
                                <img src="/svg/icon_arrow.svg" alt="Arrow" />
                            </div>
                        </button>
                    </div>
                </section>

                {/* Curriculum Wrapper with Background */}
                <div className="CurriculumWrapper">
                    {/* Wave Divider 1 */}
                    <section className="WaveDivider1">
                        <div className="WaveWrapper1">
                            <img src="/svg/wave.svg" alt="Wave" className="WaveSVG1" />
                        </div>
                    </section>

                    {/* Curriculum Section */}
                    <section className="CurriculumSection" style={{
                        backgroundImage: 'url(/img/wavebg.png)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}>
                    <div className="CurriculumInner">
                        <div className="CurriculumBadge">
                            <p>Mate Curriculum</p>
                        </div>
                        <div className="CurriculumTitle">
                            <p>Melalui Kurikulum Mate,</p>
                            <p> Kamu Bisa Memulai Petualangan Seru Belajar Bahasa Korea</p>
                        </div>
                        <div className="CurriculumContent">
                            <div className="CurriculumMapWrapper">
                                <div className="CurriculumMap">
                                    <img src="/img/landingmap.png" alt="Korean Island Map" />
                                </div>
                            </div>
                            <p className="CurriculumSubtitle">Personalisasi untuk Semua Level</p>
                        </div>
                        <div className="CurriculumCTA">
                            <button className="CTAButton CTAPurple" onClick={() => window.open(destination, "_blank")}>
                                <p>Mulai Langsung</p>
                                <div className="CTAIcon">
                                    <img src="/svg/icon_arrow.svg" alt="Arrow" />
                                </div>
                            </button>
                        </div>
                    </div>
                    </section>

                    {/* Wave Divider 2 */}
                    <section className="WaveDivider2">
                        <div className="WaveWrapper2">
                            <img src="/svg/wave.svg" alt="Wave" className="WaveSVG2" />
                        </div>
                    </section>
                </div>

                {/* Community Section */}
                <section className="CommunitySection">
                    <div className="CommunityInner">
                        <div className="CommunityHeader">
                            <div className="CommunityBadge">
                                <p>Mate Community</p>
                            </div>
                            <div className="CommunityTitle">
                                <p>Berbagi Minat hingga Menambah Teman Baru,</p>
                                <p>Komunitas Budaya Korea No.1</p>
                            </div>
                        </div>
                        <div className="CommunityContent">
                            <div className="CommunityWorld">
                                <img src="/img/landingworld.png" alt="World Community" />
                            </div>
                        </div>
                        <div className="CommunityCTA">
                            <button className="CTAButton CTAPurple" onClick={() => window.open(destination, "_blank")}>
                                <p>Mulai Langsung</p>
                                <div className="CTAIcon">
                                    <img src="/svg/icon_arrow.svg" alt="Arrow" />
                                </div>
                            </button>
                        </div>
                    </div>

                    {/* Wave Divider 3 */}
                    <section className="WaveDivider3">
                        <div className="WaveWrapper3">
                            <img src="/svg/wave.svg" alt="Wave" className="WaveSVG3" />
                        </div>
                    </section>
                </section>

                {/* Final CTA Section */}
                <section className="FinalCTASection">
                    <div className="FinalCTAInner">
                        <div className="FinalCTAHeader">
                            <div className="FinalCTALogo">
                                <img src="/svg/landinglogo.png" alt="Mate Logo" />
                            </div>
                            <div className="FinalCTATitle">
                                <p>Ready to</p>
                                <p>Talk and Learn Korean?</p>
                            </div>
                        </div>
                        <div className="FinalCTAButton">
                            <button className="CTAButton CTAPurple" onClick={() => window.open(destination, "_blank")}>
                                <p>Mulai Langsung</p>
                                <div className="CTAIcon">
                                    <img src="/svg/icon_arrow.svg" alt="Arrow" />
                                </div>
                            </button>
                        </div>
                    </div>
                </section>

                {/* Footer */}
                <footer className="Footer">
                    <div className="FooterInner">
                        <div className="FooterBrand">
                            <div className="FooterLogo">
                                <img src="/svg/matelogo 2.svg" alt="Mate Logo" />
                                <p>MATE</p>
                            </div>
                            <p className="FooterTagline">learn Korean with Mate</p>
                        </div>
                        <div className="FooterContent">
                            <div className="FooterInfo">
                                <div className="FooterCompany">
                                    <p><span>indonesia</span> | <span className="FooterBold">KOREAN CULTURE MATE</span></p>
                                    <p><span>korea</span> | <span className="FooterBold">WEBTOON TODAY</span></p>
                                </div>
                                <p className="FooterRights">All rights reserved.</p>
                                <div className="FooterAddress">
                                    <div className="FooterAddressIcon">
                                        <img src="/svg/location.svg" alt="Location" />
                                    </div>
                                    <div className="FooterAddressText">
                                        <p>Bellezza office Tower,</p>
                                        <p>Jakarta Selatan 12210, Indonesia</p>
                                    </div>
                                </div>
                                <p className="FooterCopyright">©2025 WEBTOON TODAY</p>
                            </div>
                            <div className="FooterSocial">
                                <img src="/svg/Social Icons.svg" alt="Twitter" />
                                <img src="/svg/Social Icons-1.svg" alt="Instagram" />
                                <img src="/svg/Social Icons-2.svg" alt="WhatsApp" />
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
}

export default LandingPage;
